import SuppressUndo from './customEventsProvider';

/**
 * @type { import("didi").ModuleDeclaration }
 */
export default {
  __init__: ['suppressUndo'],
  suppressUndo: ['type', SuppressUndo]
};
